export default "__VITE_ASSET__D9VkUt6___"